import { render } from "./users-official-popup.vue?vue&type=template&id=4acca77d&scoped=true"
import script from "./users-official-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./users-official-popup.vue?vue&type=script&setup=true&lang=js"

import "./users-official-popup.vue?vue&type=style&index=0&id=4acca77d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acca77d"],['__file',"src/views/administration/users/users-official-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4acca77d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4acca77d', __exports__)) {
    api.reload('4acca77d', __exports__)
  }
  
  module.hot.accept("./users-official-popup.vue?vue&type=template&id=4acca77d&scoped=true", () => {
    api.rerender('4acca77d', render)
  })

}


export default __exports__